import script from "./RegisteredUser.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisteredUser.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__